export const shouldSetPlanSourceFrequency = (sourceId) =>
  [4, 5, 6, 7, 1003, 22, 1004, 1005, 1006].includes(sourceId);
